<template>
  <div class="chart">
    <h4 class="title">{{ title }}</h4>
    <vue-apex-chart type="bar" :options="options" :series="series"/>
  </div>
</template>
<script>
  import map from 'lodash/map'
  import VueApexChart from 'vue-apexcharts'
  import Ncs from 'ncs'
  import {locales} from '../apexcharts_locales'

  export default {
    extends: Ncs.defaultComponents.NcsFullFrequencyResultTable,
    components: {VueApexChart},
    computed: {
      title() {
        return this.$t(`result.full_frequency.${this.group}.header`)
      },
      categories() {
        return this.$ncsConfig.filters.values[this.group]
      },
      translatedCategories() {
        return this.categories.map(c => this.$t(`result.full_frequency.${this.group}.values.${c}`))
      },
      series() {
        return [{data: map(this.categories, c => this.frequencyPerValue[c] ? this.perMillion(this.frequencyPerValue[c]) : 0)}]
      },
      options() {
        return {
          grid: {borderColor: '#aaa'},
          colors: ['#008751'],
          dataLabels: {enabled: false},
          xaxis: {
            categories: this.translatedCategories
          },
          yaxis: {
            labels: {formatter: this.formatNumber}
          },
          tooltip: {
            y: {
              formatter: v => `${this.formatNumber(v)} / ${this.$t('result.full_frequency.million')}`,
              title: {formatter: _seriesName => ''},
            }
          },
          chart: {
            locales,
            defaultLocale: this.$i18n.locale,
            events: {
              dataPointSelection: (event, chartContext, {dataPointIndex}) => this.showKwic(this.categories[dataPointIndex])
            }
          }
        }
      }
    },
    methods: {
      // Overwrite this method from NcsFullFrequencyResultTable since we need an unformatted number for the chart
      perMillion(frequency) {
        if (frequency.elements === 0 && frequency.elements_reference === 0) {
          // This case can only happen when there is one group value that only matches documents with no elements
          return 0
        } else {
          return Math.round(frequency.elements * 1000000 / frequency.elements_reference)
        }
      },
      formatNumber(number) {
        const delimiter = this.$t('number.format.delimiter') === '&nbsp;' ? ' ' : this.$t('number.format.delimiter')
        return this.$fn(number, {delimiter})
      }
    }
  }
</script>
<style lang="scss">
  // See: https://github.com/apexcharts/apexcharts.js/issues/2313
  .apexcharts-menu-item.exportCSV { display: none; }
</style>
